import { SelectOptions } from '@/components/form-inputs/common/select-option'
import { ComponentType } from '../component-types'

export type ComponentSelector = {
    name: string
    modelValue?: string | number
    options: SelectOptions<string | number, { isBookmarked?: boolean }>
    labelKey?: string
    placeholderTextKey?: string
    disabled?: boolean
    isLastChild?: boolean
}

export type ComponentSelectorStructure = {
    [key in ComponentType]: ComponentSelector[]
}

export const plantGroup = 'plantGroupSid'
export const plant = 'plantSid'
export const transformer = 'transformerSid'
export const generator = 'generatorSid'

export const ComponentSelectorConfiguration: ComponentSelectorStructure = {
    [ComponentType.Transformer]: [
        {
            name: plantGroup,
            modelValue: '',
            options: [],
            labelKey: 'common.label.plantGroup',
            placeholderTextKey: 'common.placeholders.plantGroup',
            disabled: false,
        },
        {
            name: plant,
            modelValue: '',
            options: [],
            labelKey: 'common.labels.plant',
            placeholderTextKey: 'common.placeholders.plant',
            disabled: false,
        },
        {
            name: transformer,
            modelValue: '',
            options: [],
            labelKey: 'transformers.conditionStatus.selector.labels.transformer',
            placeholderTextKey: 'transformers.conditionStatus.selector.placeholders.transformer',
            disabled: false,
            isLastChild: true,
        },
    ],
    [ComponentType.Turbine]: [],
    [ComponentType.Generator]: [
        {
            name: plantGroup,
            modelValue: '',
            options: [],
            labelKey: 'common.label.plantGroup',
            placeholderTextKey: 'common.placeholders.plantGroup',
            disabled: false,
        },
        {
            name: plant,
            modelValue: '',
            options: [],
            labelKey: 'common.labels.plant',
            placeholderTextKey: 'common.placeholders.plant',
            disabled: false,
        },
        {
            name: generator,
            modelValue: '',
            options: [],
            labelKey: 'generators.conditionStatus.selector.labels.generator',
            placeholderTextKey: 'generators.conditionStatus.selector.placeholders.generator',
            disabled: false,
            isLastChild: true,
        },
    ],
}
